/** Rotating NLP suggestion examples — shared between NLPInput and DayView */
export const NLP_SUGGESTIONS = [
    'Add an event, ask a question, or make a change…',
    'Try: "Soccer practice Friday at 3pm for Emma"',
    'Ask: "What does Emma have this week?"',
    'Try: "Move dentist to next Tuesday"',
    'Ask: "Cancel Friday\'s swimming lesson"',
];

/** Interval (ms) between suggestion rotations */
export const SUGGESTION_INTERVAL_MS = 3500;
